import React, {Component, Fragment} from "react";
import "react-select/dist/react-select.css";
import {setSchemasTemplates, addSchema} from "../../../../store/actions";
import {connect} from "react-redux";
import {compose} from "redux";
import FormFileds from "./FormFileds";
import {Redirect} from 'react-router-dom';

class AssetSchema extends Component {
  state = {
    contracts: [],
    assets: {},
    epc: {},
    error:false,
  };

  handleStateChange = (name, value, index) => {
    if (name === 'contracts') {
      let contracts = this.state.contracts;
      contracts[index] = value;
      this.setState({[name]: contracts})
    } else {
      this.setState({[name]: value});
    }
  };

  handleClick = async () => {
    let {contracts, assets, epc} = this.state;
    const {schemas} = this.props;
    const schemasTemplates = schemas.schemasTemplates;
    let result = {
      name: schemas.name,
      asset: {
        data: {},
        asset_schema_id: schemasTemplates.assets.id,
      },
      contracts: [],
      epc:{
        data:{},
        epc_schema_id:schemasTemplates.epc.id
      }
    };

    Object.keys(assets).map((key) => {
      if (typeof assets[key] !== 'object') {
        if(schemasTemplates.assets.data.properties[key].type === 'number' || schemasTemplates.assets.data.properties[key].type === 'integer'){
          result.asset.data[key] = +assets[key];
        } else {
          result.asset.data[key] = assets[key];
        }

      } else {
        result.asset.data[key] = typeof assets[key].key === 'boolean'
          ? assets[key].key
          : {name: assets[key].value, key: assets[key].key }
      }
    });
    contracts.map((contract,i)=> {
      result.contracts[i] = {
        data:{},
        contract_schema_id: schemas.schemasTemplates.contracts[i].id,
      };
      Object.keys(contract).map((key) => {
        console.log( schemasTemplates.contracts[i].data.properties[key].type,'cont');
        if (typeof contract[key] !== 'object') {
          if(schemasTemplates.contracts[i].data.properties[key].type === 'number' || schemasTemplates.contracts[i].data.properties[key].type === 'integer'){
            result.contracts[i].data[key] = +contract[key];
          } else {
            result.contracts[i].data[key] = contract[key];
          }
        } else {
          result.contracts[i].data[key] = typeof contract[key].key === 'boolean'
            ? contract[key].key
            : {name: contract[key].value, key: contract[key].key }
        }
      })
    });
    Object.keys(epc).map((key) => {
      if (typeof epc[key] !== 'object') {
        if(schemasTemplates.epc.data.properties[key].type === 'number' || schemasTemplates.epc.data.properties[key].type === 'integer'){
          result.epc.data[key] = +epc[key];
        } else {
          result.epc.data[key] = epc[key];
        }
      } else {
        result.epc.data[key] = typeof epc[key].key === 'boolean'
          ? epc[key].key
          : {name: epc[key].value, key: epc[key].key }
      }
    });
    console.log(result);
    const res = await this.props.addSchema(result);
    res.payload.status && this.setState({error: true});

    res.payload.detail === "successfully saved" &&
    this.props.history.push("/asset-schemas");
  };

  render() {
    const {schemas} = this.props;
    const {error} = this.state;
    return (!schemas.name && <Redirect to={'/asset-schemas'}/>) || schemas.schemasTemplates && (
      <Fragment>
        <div className="animated fadeIn">
          <div className="row justify-content-center">
            <div className="col-lg-9 col-md-12 col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="mb-0">Asset schema</h4>
                </div>
                <div className="card-body">
                  {error && <p style={{color: 'red'}}>something went wrong</p>}
                  <FormFileds headlineName={'Asset Type: '} dataOfSchemas={schemas.schemasTemplates.assets}
                              type={'assets'} handleStateChange={this.handleStateChange}/>
                  {schemas.schemasTemplates.contracts.map((contract, i) => {
                    return (
                      <FormFileds headlineName={'Contract: '} dataOfSchemas={contract} key={i} type={'contracts'}
                                  index={i} handleStateChange={this.handleStateChange}/>
                    )
                  })}
                  <FormFileds headlineName={'EPC: '} dataOfSchemas={schemas.schemasTemplates.epc} type={'epc'}
                              handleStateChange={this.handleStateChange}/>
                  <div className="row">
                    <div className="col-sm-12 text-right">
                      <button
                        className="btn btn-primary pl-4 pr-4"
                        onClick={this.handleClick}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    ) || <div>Empty</div>;
  }
}

const mapStateToProps = state => {
  return {
    schemas: state.schemas
  };
};

export default compose(
  connect(
    mapStateToProps,
    {setSchemasTemplates, addSchema}
  ),
)(AssetSchema);


// WEBPACK FOOTER //
// ./src/views/AssetSchemas/AssetSchemas/AddSchema/AddSchema.js